import { render, staticRenderFns } from "./quickview.vue?vue&type=template&id=3db1ed35"
import script from "./quickview.vue?vue&type=script&lang=ts"
export * from "./quickview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports